"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var utils_1 = require("../../utils");
exports.default = (0, styles_1.makeStyles)(function (theme) {
    return (0, styles_1.createStyles)({
        root: function (_a) {
            var canDelete = _a.canDelete;
            return ({
                color: theme.palette.primary.dark,
                paddingLeft: 6,
                paddingRight: 6,
                lineHeight: 1.33,
                fontSize: utils_1.textSizeMap.text.small,
                // NOTE: fix for ts was showing delete icon even if no onDelete was specified
                '& .MuiChip-deleteIcon': {
                    display: canDelete ? undefined : 'none',
                    color: theme.palette.primary.dark,
                },
            });
        },
    });
});
